export default {
	list: 'States',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true
		},
		StateName: {
			class: 'value',
			dataName: 'StateName',
			type: 'string',
			title: 'State Name',
			width: 100,
			hidden: false
		},
		StateCode: {
			class: 'value',
			dataName: 'StateCode',
			type: 'string',
			title: 'State Code',
			width: 100,
			hidden: false
		},
		CountryCode:{
			class: 'lookup',
			dataName: 'Country/CountryCode',
			type: 'string',
			title: 'Country Code',
			width: 100,
			hidden: false
		}
	}
}